// extracted by mini-css-extract-plugin
export var container = "_kx-0";
export var segment = "_kx-2";
export var segmentActive = "_kx-3";
export var track = "_kx-1";